export function FbLoveIcon({
  width,
  height,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_1014_110843)">
        <path
          d="M7 1.5C5.4087 1.5 3.88258 2.13214 2.75736 3.25736C1.63214 4.38258 1 5.9087 1 7.5C1 9.09128 1.63214 10.6175 2.75736 11.7427C3.88258 12.8678 5.4087 13.5 7 13.5C8.59128 13.5 10.1175 12.8678 11.2427 11.7427C12.3678 10.6175 13 9.09128 13 7.5C13 5.9087 12.3678 4.38258 11.2427 3.25736C10.1175 2.13214 8.59128 1.5 7 1.5Z"
          fill="url(#paint0_linear_1014_110843)"
        />
        <path
          d="M8.85417 4.5C7.20569 4.5 6.99944 5.868 6.99944 5.868C6.99944 5.868 6.79394 4.5 5.14544 4.5C3.55994 4.5 3.09794 6.1665 3.29144 7.0575C3.80144 9.4125 6.99944 11.0625 6.99944 11.0625C6.99944 11.0625 10.1982 9.4125 10.7082 7.0575C10.9009 6.1665 10.4382 4.5 8.85417 4.5Z"
          fill="white"
        />
      </g>
      <rect x="0.5" y="1" width="13" height="13" rx="6.5" stroke="white" />
      <defs>
        <linearGradient
          id="paint0_linear_1014_110843"
          x1="7"
          y1="1.5"
          x2="7"
          y2="13.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF6680" />
          <stop offset="1" stop-color="#E61739" />
        </linearGradient>
        <clipPath id="clip0_1014_110843">
          <rect x="1" y="1.5" width="12" height="12" rx="6" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
